import { NgModule } from "@angular/core";
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  HostListener,
} from "@angular/core";
import { TamasAlunoService } from "../tamas-aluno.service";
import { Router, ActivatedRoute } from "@angular/router";
import { AlertaConfirmDialog } from "../alerta-confirm";
import { AlertaSimplesDialog } from "../alerta-simples";
import { AlertaSocialMoreDialog } from "../alerta-socialmore";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { Location } from "@angular/common";
import * as moment from "moment";
import { AlertaInputDialog } from "../alerta-input";
import { Subject } from "rxjs";

@Component({
  selector: "app-me-feed",
  templateUrl: "./me-feed.component.html",
  styleUrls: ["./me-feed.component.css"],
})
export class MeFeedComponent implements OnInit {
  // @HostListener('touchstart', ['$event']) onTouchStart(event: Event): void {
  //   if (event) {
  //     //event.preventDefault();
  //   }
  //   console.log(event.type);
  // }

  @ViewChild("scrollMe") private myScrollContainer: ElementRef;
  defaultTouch = { x: 0, y: 0, time: 0 };

  @HostListener("touchstart", ["$event"])
  //@HostListener('touchmove', ['$event'])
  @HostListener("touchend", ["$event"])
  @HostListener("touchcancel", ["$event"])
  handleTouch(event) {
    let touch = event.touches[0] || event.changedTouches[0];

    // check the events
    if (event.type === "touchstart") {
      this.defaultTouch.x = touch.pageX;
      this.defaultTouch.y = touch.pageY;
      this.defaultTouch.time = event.timeStamp;
    } else if (event.type === "touchend") {
      let deltaX = touch.pageX - this.defaultTouch.x;
      let deltaY = touch.pageY - this.defaultTouch.y;
      let deltaTime = event.timeStamp - this.defaultTouch.time;

      // simulte a swipe -> less than 500 ms and more than 60 px
      if (deltaTime < 500) {
        // touch movement lasted less than 500 ms
        if (Math.abs(deltaX) > 60) {
          // delta x is at least 60 pixels
          if (deltaX > 0) {
            this.doSwipeRight(event);
          } else {
            this.doSwipeLeft(event);
          }
        }

        if (Math.abs(deltaY) > 60) {
          // delta y is at least 60 pixels
          if (deltaY > 0) {
            this.doSwipeDown(event);
          } else {
            this.doSwipeUp(event);
          }
        }
      }
    }
  }

  doSwipeLeft(event) {
    console.log("swipe left", event);
  }

  doSwipeRight(event) {
    console.log("swipe right", event);
  }

  doSwipeUp(event) {
    console.log("swipe up", event);
  }

  doSwipeDown(event) {
    console.log("swipe down", event);
    //console.log(window.pageYOffset);
    console.log(this.myScrollContainer.nativeElement.scrollTop);
    if (this.myScrollContainer.nativeElement.scrollTop == 0) {
      this.loadNew = true;
      this.contadorIndex = 0;
      this.carregarFeed("new");
    }
  }

  hideCL: boolean = false;
  hideAB: boolean = true;
  indexB: any = 0;
  arrFeedPost: any[] = [];
  arrComentarios: any[] = [];
  arrReact: any[] = [];
  arrIE: any[] = [];
  urlFoto: any = "";
  urlFotoFeed: any = "";
  contadorIndex: any = 0;
  loadMore: boolean = false;
  feedEmpty: boolean = true;
  targetElement: Element;
  loadNew: boolean = false;
  txtmsg: any = "";
  constructor(
    public tmaService: TamasAlunoService,
    private _location: Location,
    public router: Router,
    public route: ActivatedRoute,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    //this.hideCL = true;
    //this.showRT = this._showRT.asObservable();
    this.urlFoto = this.tmaService.urlRepositorioS3 + "/users-profile-picture/";
    this.urlFotoFeed = this.tmaService.urlRepositorioS3 + "/users-feed/";
    this.carregarFeed("start");
  }

  onScroll(event): void {
    console.log("scroll utilizado");
    //comparar altura
    let tracker = event.target;
    //console.log(tracker);
    // console.log(tracker.clientHeight);
    // console.log(tracker.scrollHeight);
    // console.log(tracker.scrollTop);
    // console.log(this.myScrollContainer.nativeElement.scrollHeight);
    console.log(tracker.scrollTop);
  }

  onBlur(event) {
    //do nothing
  }

  carregarFeed(tipo: any) {
    if (tipo == "start") this.hideCL = false;

    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      numIndex: this.contadorIndex,
    };

    this.tmaService.listarFeed(customParams).subscribe(
      (qRes) => {
        this.hideCL = true;
        console.log(qRes);
        if (qRes["res"] == "done") {
          this.loadNew = false;
          if (tipo == "new") {
            this.arrFeedPost = [];
            this.arrIE = [];
            this.arrComentarios = [];
          }

          this.arrFeedPost = this.arrFeedPost.concat(qRes["arrResultado"]);
          this.arrIE = this.arrIE.concat(qRes["arrEstatistica"]);
          this.arrComentarios = this.arrComentarios.concat(
            qRes["arrComentarios"].reverse()
          );

          this.contadorIndex += this.arrFeedPost.length;
          if (qRes["arrResultado"].length < 10) {
            this.loadMore = false;
          } else {
            this.loadMore = true;
          }

          this.arrComentarios.forEach((qItem, index) => {
            if (qItem.DifDias > 7) {
              var tempoSem = Math.round(qItem.DifDias / 7);
              if (tempoSem > 56) {
                var tempoY = Math.round(qItem.DifDias / 56);
                this.arrComentarios[index].dt = tempoY + " a";
                //console.log(qItem.DifDias % 7);
              } else {
                this.arrComentarios[index].dt = tempoSem + " sem";
                //console.log(qItem.DifDias / 7);
              }
            } else {
              if (qItem.DifDias == 0) {
                var a = moment(
                  qItem.Hora.Hours + ":" + qItem.Hora.Minutes,
                  "HH:mm:ss"
                );
                var now = moment();
                console.log(now.diff(a, "hours"));
                if (now.diff(a, "hours") > 0) {
                  this.arrComentarios[index].dt = now.diff(a, "hours") + " h";
                } else {
                  this.arrComentarios[index].dt = now.diff(a, "minutes") + " m";
                }
              } else {
                this.arrComentarios[index].dt = qItem.DifDias + " d";
              }
            }
          });

          //percorrer array feed
          this.arrFeedPost.forEach((qItem, index) => {
            this.arrFeedPost[index].qtyC = this.arrIE.find(
              (x) => x.idpost == qItem.Id
            ).qtycomentarios;
            this.arrFeedPost[index].qtyR = qItem.total;
            //this.arrFeedPost[index].qtyR = this.arrIE.find(x => x.idpost == qItem.Id).qtyreacoes;
            this.arrFeedPost[index].dataform = moment(
              this.arrFeedPost[index].DataFull
            ).format("DD/MM/YYYY");
            this.arrFeedPost[index].horaform = moment(
              this.arrFeedPost[index].HoraRegistro.Hours +
                ":" +
                this.arrFeedPost[index].HoraRegistro.Minutes,
              "HH:mm"
            ).format("HH:mm");
            console.log(this.arrFeedPost[index].dataform);
          });

          //percorrer o array de reações
          this.arrReact = qRes["arrReacoes"];
          this.arrReact.forEach((qItem, index) => {
            //comparar com a data atual, se for inferior a 24h, exibe apenas há X horas, caso contrário data completa

            //if(this.arrFeedPost[index].Id == qItem.IdPost)
            if (this.arrFeedPost.find((x) => x.Id == qItem.IdPost)) {
              console.log("existe reação");
              //dessa forma ao renderizar os posts na view, terei o campo reacao, se for diferente de undefined, significa que o usuário já reagiu a esse post
              this.arrFeedPost.find((x) => x.Id == qItem.IdPost).reacao =
                qItem.TipoReacao;
            }
          });
          console.log(this.arrFeedPost);
          if (this.arrFeedPost.length != 0) this.feedEmpty = false;
        } else {
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: {
              tituloAlerta: "Aviso",
              textoAlerta:
                "Ocorreu um erro ao realizar esta operação Tente novamente",
              iconAlerta: "warning",
            },
          });
        }
      },
      (error) => {
        this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: {
            tituloAlerta: "Aviso",
            textoAlerta:
              "Verifique sua conexão com a internet. Tente novamente",
            iconAlerta: "warning",
          },
        });
      }
    );
  }

  renderizarFeed(lPosts: any): void {}

  sharePost(idpost: any, nickusuario: any) {
    // this.ngNavigatorShareService
    //   .share({
    //     title: "Publicação de " + nickusuario,
    //     text: "Confira esse post no Tamas",
    //     url: "https://tamasapp.com/me/post/" + nickusuario + "/" + idpost,
    //   })
    //   .then((response) => {
    //     console.log(response);
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //     //alert("lalalal");
    //     this.copyToClipboard2(
    //       "https://tamasapp.com/me/" + nickusuario + "/" + idpost
    //     );
    //   });
  }

  copyToClipboard2(item) {
    document.addEventListener("copy", (e: ClipboardEvent) => {
      e.clipboardData.setData("text/plain", item);
      e.preventDefault();
      document.removeEventListener("copy", null);
    });
    document.execCommand("copy");
    const erroCriar = this.dialog.open(AlertaSimplesDialog, {
      disableClose: true,
      data: {
        tituloAlerta: "Link do Post",
        textoAlerta: "O link para esse post foi copiado com sucesso!",
        iconAlerta: "",
      },
    });
  }

  denunciar(idpost: any, nickuser: any): any {
    this.hideCL = false;
    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      idPost: idpost,
      usuarioPost: nickuser,
    };
    this.tmaService.reportPost(customParams).subscribe(
      (qRes) => {
        this.hideCL = true;
        console.log(qRes);
        if (qRes["res"] == "done") {
          //comentário realizado, trazer os últimos
          console.log(qRes);
          const reportRreal = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: {
              tituloAlerta: "Aviso",
              textoAlerta:
                "Sua denúncia foi enviada com sucesso para o setor responsável.",
              iconAlerta: "done",
            },
          });
        } else {
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: {
              tituloAlerta: "Aviso",
              textoAlerta:
                "Ocorreu um erro ao realizar esta operação Tente novamente",
              iconAlerta: "warning",
            },
          });
        }
      },
      (error) => {
        this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: {
            tituloAlerta: "Aviso",
            textoAlerta:
              "Verifique sua conexão com a internet. Tente novamente",
            iconAlerta: "warning",
          },
        });
      }
    );
  }

  reagir(idreacao: any, idpost: any, nickuser: any): void {
    console.log(this.arrFeedPost.find((x) => x.Id == idpost).reacao);
    //setar no obj posts a reação e tbm enviar pro servidor
    if (this.arrFeedPost.find((x) => x.Id == idpost).reacao == undefined) {
      //ainda n reagiu
      console.log("não reagiu");
      this.callIR(idpost, idreacao, nickuser);
    } else {
      //já reagiu, oq fazer?
      //check se é a msm reação, se for vai 'disreagir'
      if (this.arrFeedPost.find((x) => x.Id == idpost).reacao == idreacao) {
        this.arrFeedPost.find((x) => x.Id == idpost).reacao = "";
        this.callUR(idpost, nickuser);
      } else {
        this.callIR(idpost, idreacao, nickuser);
      }
    }
  }

  callIR(idpost: any, idreacao: any, nickuser: any) {
    this.arrFeedPost.find((x) => x.Id == idpost).reacao = idreacao;
    //fazer chamada servidor
    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      idPost: idpost,
      usuarioPost: nickuser,
      idReacao: idreacao,
    };
    this.tmaService.addReacao(customParams).subscribe(
      (qRes) => {
        this.hideCL = true;
        console.log(qRes);
        if (qRes["res"] == "done") {
          //comentário realizado, trazer os últimos
          console.log(qRes);
        } else {
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: {
              tituloAlerta: "Aviso",
              textoAlerta:
                "Ocorreu um erro ao realizar esta operação Tente novamente",
              iconAlerta: "warning",
            },
          });
        }
      },
      (error) => {
        this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: {
            tituloAlerta: "Aviso",
            textoAlerta:
              "Verifique sua conexão com a internet. Tente novamente",
            iconAlerta: "warning",
          },
        });
      }
    );
  }

  callUR(idpost: any, nickuser: any) {
    //this.arrFeedPost.find(x => x.Id == idpost).reacao = idreacao;
    //fazer chamada servidor
    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      idPost: idpost,
      usuarioPost: nickuser,
    };
    this.tmaService.remReacao(customParams).subscribe(
      (qRes) => {
        this.hideCL = true;
        console.log(qRes);
        if (qRes["res"] == "done") {
          //comentário realizado, trazer os últimos
          console.log(qRes);
        } else {
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: {
              tituloAlerta: "Aviso",
              textoAlerta:
                "Ocorreu um erro ao realizar esta operação Tente novamente",
              iconAlerta: "warning",
            },
          });
        }
      },
      (error) => {
        this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: {
            tituloAlerta: "Aviso",
            textoAlerta:
              "Verifique sua conexão com a internet. Tente novamente",
            iconAlerta: "warning",
          },
        });
      }
    );
  }

  postMore(nomeusuario: any, idpost: any): void {
    var itsme = false;
    if (this.tmaService.hcNomeUsuario == nomeusuario) itsme = true;

    console.log("clicou");
    const alertaInfoPremium = this.dialog.open(AlertaSocialMoreDialog, {
      width: "270px",
      data: { origem: "feed", ms: itsme },
    });
    alertaInfoPremium.afterClosed().subscribe((result) => {
      console.log(result);
      if (result == 1) {
        this.router.navigate(["/me/post/" + nomeusuario + "/" + idpost]);
      }

      if (result == 2) {
        //compartilhar e copiar
        this.sharePost(idpost, nomeusuario);
      }

      if (result == 4) {
        //report
        this.denunciar(idpost, nomeusuario);
      }

      if (result == 5) {
        //excluir
        this.excluir(idpost);
      }
    });

    //setar no obj posts a reação e tbm enviar pro servidor
  }

  excluir(idpost: any): void {
    const enviarP = this.dialog.open(AlertaConfirmDialog, {
      //width: '250px',
      disableClose: true,
      data: {
        iconAlerta: "warning",
        tituloAlerta: "Atenção",
        textoAlerta: "Confirma a exclusão dessa publicação? ",
        textoCancel: "Não",
        textoConfirm: "SIM",
      },
    });

    enviarP.afterClosed().subscribe((result) => {
      if (result) {
        //true - do
        this.hideCL = false;
        let customParams = {
          //lista: localStorage.getItem('turboCart'),
          email: this.tmaService.hcEmail,
          senha: this.tmaService.hcSenha,
          idPost: idpost,
        };
        this.tmaService.excluirPost(customParams).subscribe(
          (qRes) => {
            this.hideCL = true;
            console.log(qRes);
            if (qRes["res"] == "done") {
              var idxExc = this.arrFeedPost.findIndex((x) => x.Id == idpost);
              if (idxExc != -1) {
                this.arrFeedPost.splice(idxExc, 1);
              }
              const exdone = this.dialog.open(AlertaSimplesDialog, {
                disableClose: true,
                data: {
                  tituloAlerta: "Aviso",
                  textoAlerta: "Publicação excluída com sucesso",
                  iconAlerta: "",
                },
              });
            } else {
              const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                disableClose: true,
                data: {
                  tituloAlerta: "Aviso",
                  textoAlerta:
                    "Ocorreu um erro ao realizar esta operação Tente novamente",
                  iconAlerta: "warning",
                },
              });
            }
          },
          (error) => {
            this.hideCL = true;
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose: true,
              data: {
                tituloAlerta: "Aviso",
                textoAlerta:
                  "Verifique sua conexão com a internet. Tente novamente",
                iconAlerta: "warning",
              },
            });
          }
        );
      }
    });
  }

  goPost(idpost: any, nomeusuario: any): void {
    this.router.navigate(["/me/post/" + nomeusuario + "/" + idpost]);
  }

  comentar(idpost: any, nomeusuario: any): void {
    const addNT = this.dialog.open(AlertaInputDialog, {
      width: "250px",
      disableClose: true,
      data: {
        iconAlerta: "",
        textoInput: "Comentario",
        tipoInput: "text",
        nomeInput: "nome",
        tituloAlerta: "Comentário",
        textoAlerta: "Digite sua mensagem abaixo",
        textoCancel: "Cancelar",
        textoConfirm: "OK",
      },
    });
    addNT.afterClosed().subscribe((result) => {
      console.log(result);
      if (result != false && result != undefined) {
        //this.enviarMsg(idpost, nomeusuario, result);
      }
    });
  }

  enviarMsg(idpost: any, nomeusuario: any): void {
    var txtcomentario = this.txtmsg;
    //definir tamanho mínimo?
    this.hideCL = false;
    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      comentario: txtcomentario,
      idPost: idpost,
      usuarioPost: nomeusuario,
      idc: 0,
    };
    this.tmaService.addComentario(customParams).subscribe(
      (qRes) => {
        this.hideCL = true;
        console.log(qRes);
        if (qRes["res"] == "done") {
          //comentário realizado, trazer os últimos
          var fakeC = {
            IdPost: idpost,
            IdAlunoC: this.tmaService.hcUid,
            UsuarioNome: this.tmaService.hcNomeUsuario,
            Nome: this.tmaService.hcNome,
            Comentario: txtcomentario,
          };
          this.arrComentarios = this.arrComentarios.concat(fakeC);
          console.log(this.arrComentarios);
          this.txtmsg = "";
          // const comentou = this.dialog.open(AlertaSimplesDialog, {
          //   disableClose: true,
          //   data: { tituloAlerta: "Aviso", textoAlerta: "Comentário realizado", iconAlerta: '' }
          // })
        } else {
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: {
              tituloAlerta: "Aviso",
              textoAlerta:
                "Ocorreu um erro ao realizar esta operação Tente novamente",
              iconAlerta: "warning",
            },
          });
        }
      },
      (error) => {
        this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: {
            tituloAlerta: "Aviso",
            textoAlerta:
              "Verifique sua conexão com a internet. Tente novamente",
            iconAlerta: "warning",
          },
        });
      }
    );
  }

  goPerfil(nickusuario: any): void {
    this.tmaService.gUrlAnterior = this.router.url;
    this.router.navigate(["/" + nickusuario]);
  }

  novoPost(): void {
    this.router.navigate(["/me/create/1"]);
  }

  myRefreshEvent(event: Subject<any>, message: string) {
    setTimeout(() => {
      alert(message);
      event.next();
    }, 3000);
  }

  alert(message: string) {
    alert(message);
  }

  toggleOpacity(): void {
    this.hideAB = !this.hideAB;
    // console.log(this.bRT);
    // this._showRT.next(true);
    // if(this.showRT._isScalar){
    //   this._showRT.next(false);
    // }
    // else{
    //   this._showRT.next(true);
    // }
  }
}
